import { render, staticRenderFns } from "./WebInvoice.vue?vue&type=template&id=e485171a&scoped=true&"
import script from "./WebInvoice.vue?vue&type=script&lang=js&"
export * from "./WebInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e485171a",
  null
  
)

export default component.exports